// extracted by mini-css-extract-plugin
module.exports = {"noTraining":"NoTrainings_noTraining__3w8nQ","submitted":"NoTrainings_submitted__3-KhK","borderContent":"NoTrainings_borderContent__8adNr"};